import { Produkt } from "../store/types/organizacje";
import { getData } from "./fetchData";

export const authService = {
  login,
  getLoginToken,
  signup,
  signupToProduct,
  logout,
  confirmEmail,
  getPersonalData,
  changePersonalData,
  resendConfirmationEmail,
  dajDaneSesji,
  changePassword,
  resetPasswordSendEmail,
  resetPassword,
  deleteAccount
};

function login(email: string, password: string) {
  return getData("auth", { UserName: email, Password: password });
}

function getLoginToken(email: string, password: string, product: Produkt) {
  return getData(`posrednik/zaloguj`, {
    Email: email,
    Haslo: password,
    Produkt: product
  });
}

function signup(email: string, password: string) {
  return getData(`konto/dodaj`, {
    Email: email,
    Haslo: password
  });
}

function signupToProduct(email: string, password: string, product: Produkt) {
  return getData(`posrednik/dodaj-konto`, {
    Email: email,
    Haslo: password,
    Produkt: product
  });
}

function logout() {
  return getData(`auth/logout`, {});
}

function confirmEmail(email: string, token: string) {
  return getData(`konto/potwierdzEmail`, { Email: email, Token: token });
}

function getPersonalData() {
  return getData(`konto/daj`, {});
}

function changePersonalData(imie: string, nazwisko: string) {
  return getData(`konto/zmien`, {
    Imie: imie,
    Nazwisko: nazwisko
  });
}

function resendConfirmationEmail() {
  return getData(`konto/przygotujpotwierdzenieemail`, {});
}

function dajDaneSesji() {
  return getData(`sesja/dajdane`, {});
}

function changePassword(pass: string, newPass: string) {
  return getData(`konto/zmienhaslo`, {
    Haslo: pass,
    NoweHaslo: newPass
  });
}

function resetPasswordSendEmail(email: string) {
  return getData(`konto/przygotujresethasla`, {
    Email: email
  });
}

function resetPassword(email: string, token: string, haslo: string) {
  return getData(`konto/resetujhaslo`, {
    Email: email,
    Token: token,
    NoweHaslo: haslo
  });
}

function deleteAccount(password: string) {
  return getData(`konto/usun`, {
    Haslo: password
  });
}
